import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';

import Header from './Header';
import Filter from './Filter';
import Items from './Items';
import ModalForm from './ModalForm';

export default function Index(props) {
    const [id, setId] = useState(0);
    const [openForm, setOpenForm] = useState(false);

    useEffect(() => {

    }, []);

    const onEdit = (item) => {
        setId(item.id);
        setOpenForm(true);
    };

    return (
        <Row justify='center'>
            <Col span={24}>
                <Header
                    onNew={() => {
                        setOpenForm(true);
                        setId(0);
                    }}
                />
                <Filter />
                <Items 
                    onEdit={onEdit}
                />
                <ModalForm
                    id={id}
                    open={openForm}
                    onCancel={() => {
                        setOpenForm(false)
                        setId(0);
                    }}
                />
            </Col>
        </Row>
    );
}